import React, { useState } from "react";
import { Pane, Button, TextInputField, SavedIcon, toaster } from "evergreen-ui";
import { useForm } from "react-hook-form";
import { User } from "../api/users";
import { changePassword } from "../api/cognito";

type Props = {
  user: User;
};

type formShape = {
  newPassword: string;
};

const UserPasswordForm = ({ user }: Props) => {
  const [saving, setSaving] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<formShape>({
    defaultValues: {
      newPassword: "",
    },
  });

  const handleFormSubmit = async (data: formShape) => {
    setSaving(true);

    try {
      await changePassword(user.id, data.newPassword);
      toaster.success("Changed password successfully!");
      reset();
    } catch (err: any) {
      toaster.danger("Error saving: " + err.message);
    }

    setSaving(false);
  };

  return (
    <Pane is="form" onSubmit={handleSubmit(handleFormSubmit)}>
      <Pane display="flex">
        <TextInputField
          label="New Password"
          type="password"
          flexGrow={1}
          {...register("newPassword", { required: true, minLength: 8 })}
          isInvalid={!!errors.newPassword}
          validationMessage={errors.newPassword ? "Password is required and must be at least 8 characters." : undefined}
        />
      </Pane>
      <Pane display="flex" justifyContent="flex-end">
        <Button appearance="primary" iconBefore={SavedIcon} type="submit" isLoading={saving}>
          Save
        </Button>
      </Pane>
    </Pane>
  );
};

export default UserPasswordForm;
